var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTripSideCol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.2105C0 17.2295 0.43875 18.1442 1.125 18.7811V20.2632C1.125 21.2242 1.87875 22 2.8125 22C3.74625 22 4.5 21.2242 4.5 20.2632V19.6842H13.5V20.2632C13.5 21.2126 14.2537 22 15.1875 22C16.11 22 16.875 21.2242 16.875 20.2632V18.7811C17.5613 18.1442 18 17.2295 18 16.2105V4.63158C18 0.578947 13.9725 0 9 0C4.0275 0 0 0.578947 0 4.63158V16.2105ZM3.9375 17.3684C3.00375 17.3684 2.25 16.5926 2.25 15.6316C2.25 14.6705 3.00375 13.8947 3.9375 13.8947C4.87125 13.8947 5.625 14.6705 5.625 15.6316C5.625 16.5926 4.87125 17.3684 3.9375 17.3684ZM14.0625 17.3684C13.1287 17.3684 12.375 16.5926 12.375 15.6316C12.375 14.6705 13.1287 13.8947 14.0625 13.8947C14.9963 13.8947 15.75 14.6705 15.75 15.6316C15.75 16.5926 14.9963 17.3684 14.0625 17.3684ZM15.75 10.4211H2.25V4.63158H15.75V10.4211Z",
    fill: "#1890FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripSideCol);
export default __webpack_public_path__ + "static/media/tripSideCol.5cac2b96cd80a6635572b2ff45567a8d.svg";
export { ForwardRef as ReactComponent };